var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionsMenu',[_c('delete-community',{attrs:{"community-id":_vm.community.id}}),_c('unreport-community',{attrs:{"community-id":_vm.community.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }